var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"module-layout-test"},[_c('el-button',{attrs:{"size":"small","icon":"el-icon-back"},on:{"click":_vm.backToResources}},[_vm._v("返回资源管理")]),_c('el-empty',{attrs:{"description":(_vm.$route.meta.layoutTestName || '资源') + '测试入口，页面跳转正常'}}),_c('p',[_vm._v("此页面仅用于验证布局入口，不提交业务数据。")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }